import React, {useEffect, useState} from 'react';
import config from "../../config";
import {useAuth} from "../../utils/auth.context";
import '../../css/ResourcesBlock.css';
import {
    addResource,
    deleteAllResources,
    deleteResource,
    deleteTempResources,
    editResource,
    getProjectLocales,
    getResources,
    getResourcesNoValue,
    getTempResources,
    importResource,
    publishResources
} from "../../services/apiService";
import DeleteAllModal from "../../components/DeleteAllModal";
import {t} from "../../components/Translate";
import {getCurrentUser} from "../../services/authService";
import {toast} from "react-toastify";
import ChangesModal from "../../components/ChangesModal";
import EditIcon from '../../assets/img/edit.png'
import DeleteIcon from '../../assets/img/delete.png'
import ResourcesButtons from "./resources/ResourcesButtons";
import AddKeyForm from "./resources/AddKeyForm";
import ImportForm from "./resources/ImportForm";
import SearchAndFilter from "./resources/SearchAndFilter";
import ResourcesTable from "./resources/ResourcesTable";
import DeleteModal from "../../components/DeleteModal";
import ExportModal from "../../components/ExportModal";
import Tooltip from "../../components/Tooltip";
import ConfirmModal from "../../components/ConfirmModal";

const API_URL = process.env.REACT_APP_API_URL;
const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};


const ResourcesBlock = ({project}) => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isImportFormVisible, setIsImportFormVisible] = useState(false);
    const [resources, setResources] = useState({});
    const [resourcesWithoutValue, setResourcesWithoutValue] = useState([]);
    const [importData, setImportData] = useState("");
    const [locales, setLocales] = useState([]);
    const [newKey, setNewKey] = useState({keyname: '', translations: {}});
    const [editingKey, setEditingKey] = useState(null);
    const [editedTranslations, setEditedTranslations] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isHtml, setIsHtml] = useState(false);
    const [importState, setImportState] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const {user} = useAuth();
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [deleteModalResourceKey, setDeleteModalResourceKey] = useState();
    const [isChangesModalOpen, setIsChangesModalOpen] = useState(false);
    const [addResp, setAddResp] = useState({});
    const [inputError, setInputError] = useState('');
    const [resourceTypeFilter, setResourceTypeFilter] = useState('all');
    const [tempResources, setTempResources] = useState([]);
    const [description, setDescription] = useState('');
    const [confirmModalAction, setConfirmModalAction] = useState();


    useEffect(() => {
        const uniqueGroups = new Set();
        for (const key of Object.keys(resources)) {
            if (key.includes('_')) {
                const groupName = key.split('_')[0];
                uniqueGroups.add(groupName);
            }
        }
    }, [resources]);


    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                await Promise.all([
                    getResourcesList(),
                    getProjectLocalesList(),
                    getResourcesNoValueList(),
                    getTempResourcesList()
                ]);
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [project, importState]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    getResourcesNoValueList()
                ]);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [addResp]);

    const getProjectLocalesList = async () => {
        try {
            const data = await getProjectLocales(project.name);
            setLocales(data);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const getResourcesList = async () => {
        try {
            const data = await getResources(project.id);
            setResources(data);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const getResourcesNoValueList = async () => {
        try {
            const data = await getResourcesNoValue(project.id);
            setResourcesWithoutValue(data);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const getTempResourcesList = async () => {
        try {
            const data = await getTempResources(project.id);
            setTempResources(data);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const deleteTempResourcesList = async () => {
        try {
            await deleteTempResources(project.id);
            setImportState(!importState)
            setTempResources([]);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const showChanges = async () => {
        setIsChangesModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setIsChangesModalOpen(false);
    }

    const openModal = () => setIsModalOpen(true);

    const openDeleteModal = (keyName) => {
        setIsDeleteModalOpen(true);
        setDeleteModalResourceKey(keyName)
    }

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setIsChangesModalOpen(false);
        setIsExportModalOpen(false);
        setDeleteModalResourceKey(null);
    }

    const closeConfirmModal = () => {
        closeDeleteModal();
        closeExportModal();
        setIsConfirmModalOpen(false);
        setConfirmModalAction(undefined)
    }

    const closeExportModal = () => {
        setIsExportModalOpen(false);
    }


    const publishResourcesCall = async () => {
        try {
            await publishResources(project.id);
            setImportState(!importState)
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const confirmDeleteAll = async () => {
        try {
            await deleteAllResources(project.id);
            setResources({});
            setTempResources([]);
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        } finally {
            closeModal();
        }
    };

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible);
        setDescription('')
        if (isFormVisible) {
            setNewKey({keyname: '', translations: {}});
            setEditingKey(null);
            setIsHtml(false);
        }
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value)
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        const regex = /^[a-zA-Z0-9_]*$/;
        if (name === 'keyname') {
            if (!regex.test(value)) {
                setInputError(t(currentUser.language, "newKeyErrorMessage"));
            } else {
                setInputError('');
            }
            setNewKey({
                ...newKey,
                keyname: value
            });

        } else if (editingKey) {
            setEditedTranslations({
                ...editedTranslations,
                [name]: value
            });
        } else {
            setNewKey({
                ...newKey,
                translations: {
                    ...newKey.translations,
                    [name]: value
                }
            });
        }
    };

    const handleAddKey = async () => {
        try {
            await addResource(project.id, newKey.keyname, description, newKey.translations, isHtml);
            setImportState(!importState)

            setNewKey({keyname: '', translations: {}});
            setIsHtml(false);
            setIsFormVisible(false);
            setAddResp(true);

            setTimeout(() => {
                setAddResp(false);
            }, 500);

        } catch (error) {
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const handleEditClick = (keyName) => {

        setDescription(resourcesWithoutValue?.filter(r => r.keyName === keyName)[0]?.description ?? "")

        setIsHtml(resourcesWithoutValue?.find(r => r.keyName === keyName)?.isHtml)

        setEditingKey(keyName);

        setNewKey({
            keyname: keyName,
            translations: {}
        });

        setEditedTranslations(resources[keyName].reduce((acc, item) => ({
            ...acc,
            [item.locale]: item.value
        }), {}));

        setIsFormVisible(true);
    };

    const handleEditKey = async () => {
        try {
            const oldKeyname = editingKey;
            const newKeyname = newKey.keyname;
            await editResource(project.id, oldKeyname, description, editedTranslations, isHtml, newKeyname);
            setImportState(!importState)

            setEditingKey(null);
            setNewKey({keyname: '', translations: {}});
            setEditedTranslations({});
            setIsFormVisible(false);

            await getTempResourcesList();
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const confirmResourceDelete = async (keyName) => {
        try {
            await deleteResource(project.id, keyName);
            setResources(prevResources => {
                const newResources = {...prevResources};
                delete newResources[keyName];
                return newResources;
            });
            closeDeleteModal();
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
            closeDeleteModal();
        }
    };

    const handleImportSubmit = async () => {
        try {
            setIsLoading(true)
            await importResource(project.id, importData);
            setImportState(!importState);
            setImportData("");
            setIsImportFormVisible(false);
            setIsLoading(false)
        } catch (error) {
            console.error(error);
            toast.error(t(currentUser.language, 'error'), {position: "top-right", theme: "colored"});
        }
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
        setCurrentPage(1);
    };

    const handleImportClick = () => {
        setIsImportFormVisible(!isImportFormVisible);
    };

    const filteredResources = Object.keys(resources).filter((keyName) => {
        const keyMatches = keyName.toLowerCase().includes(searchQuery);
        const translationMatches = resources[keyName].some(item =>
            item.value.toLowerCase().includes(searchQuery)
        );
        const description = resourcesWithoutValue?.find(r => r.keyName === keyName)?.description;
        const descriptionMatches = description !== null && description !== undefined ? description.toLowerCase().includes(searchQuery) : false;
        const isHtml = resourcesWithoutValue?.find(r => r.keyName === keyName)?.isHtml
        const matchesType = resourceTypeFilter === 'all'
            || (resourceTypeFilter === 'html' && isHtml)
            || (resourceTypeFilter === 'text' && !isHtml);

        if (!matchesType) {
            return false;
        }

        return (keyMatches || translationMatches || descriptionMatches);
    });

    const paginatedResources = filteredResources.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const formatPreview = (items, isHtml) => {
        return items.map(item => (
            <div
                key={item.locale} className="locale-preview">
                <div className="locale-circle">{item.locale}</div>
                <div className="locale-value"
                     onClick={() => {
                         navigator.clipboard.writeText(item.value)
                         toast.info(t(currentUser.language, 'copied'), {
                             position: "top-right",
                             theme: "light",
                             autoClose: 500
                         });
                     }}>
                    <span dangerouslySetInnerHTML={{__html: item.value}}/>
                </div>
            </div>
        ));
    };

    const rows = paginatedResources.map(keyName => {
        const items = resources[keyName];

        let isHtml = false;

        if (resourcesWithoutValue !== undefined && resourcesWithoutValue !== null && resourcesWithoutValue !== {}) {
            isHtml = resourcesWithoutValue?.filter(r => r.keyName === keyName)[0]?.isHtml
        }

        const preview = formatPreview(items, isHtml);

        return (
            <tr key={keyName}>
                <td
                    onClick={() => {
                        navigator.clipboard.writeText(keyName);
                        toast.info(t(currentUser.language, 'copied'), {
                            position: "top-right",
                            theme: "light",
                            autoClose: 500,
                        });
                    }}
                    style={{padding: '10px', cursor: 'pointer'}}
                >
                    {keyName}
                </td>

                <td style={{width: '30%', padding: '10px'}}>
                    {resourcesWithoutValue?.filter(r => r.keyName === keyName)[0]?.description}
                </td>

                <td style={{width: '30%', padding: '10px'}}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        {preview}
                    </div>
                </td>

                <td style={{width: '5%', textAlign: 'center', padding: '10px'}}>
                    <span className={`resource-type-badge ${isHtml ? 'html' : 'text'}`}>
                        {isHtml ? 'Html' : 'Text'}
                    </span>
                </td>

                <td style={{width: '10%', textAlign: 'center', padding: '10px'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '28px', justifyContent: 'center'}}>

                        <Tooltip text={t(currentUser.language, "edit")}>
                            <img
                                className="edit-img"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditClick(keyName);
                                }}
                                width={25}
                                height={25}
                                src={EditIcon}
                                alt="Edit"
                                style={{cursor: 'pointer'}}
                            />
                        </Tooltip>

                        {user.data.role === config.roles.manager && (
                            <Tooltip text={t(currentUser.language, "delete")}>
                                <img
                                    className="delete-img"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openDeleteModal(keyName);
                                    }}
                                    width={25}
                                    height={25}
                                    src={DeleteIcon}
                                    alt="Delete"
                                    style={{cursor: 'pointer'}}
                                />
                            </Tooltip>
                        )}
                    </div>
                </td>
            </tr>
        );
    });

    const totalPages = Math.ceil(filteredResources.length / rowsPerPage);

    const pageNumbers = [];

    for (let i = Math.max(1, currentPage - 1); i <= Math.min(currentPage + 1, totalPages); i++) {
        pageNumbers.push(i);
    }

    if (currentPage > 2) {
        pageNumbers.unshift('...');
        pageNumbers.unshift(1);
    }

    if (currentPage < totalPages - 1) {
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
    }

    const handlePageClick = (pageNumber) => {
        if (pageNumber === '...') return;
        setCurrentPage(pageNumber);
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };


    return (
        <div>
            <ResourcesButtons
                openConfirmModal={() => setIsConfirmModalOpen(true)}
                setConfirmModalAction={setConfirmModalAction}
                openExportModal={() => setIsExportModalOpen(true)}
                isFormVisible={isFormVisible}
                toggleFormVisibility={toggleFormVisibility}
                isImportFormVisible={isImportFormVisible}
                handleImportClick={handleImportClick}
                openModal={openModal}
                tempResources={tempResources}
                publishResourcesCall={publishResourcesCall}
                deleteTempResourcesList={deleteTempResourcesList}
                showChanges={showChanges}
                user={user}
                config={config}
                currentUser={currentUser}
                project={project}
            />

            <SearchAndFilter
                searchQuery={searchQuery}
                handleSearchChange={handleSearchChange}
                resourceTypeFilter={resourceTypeFilter}
                setResourceTypeFilter={setResourceTypeFilter}
                currentUser={currentUser}
            />

            <ResourcesTable
                isLoading={isLoading}
                rows={rows}
                currentUser={currentUser}
                currentPage={currentPage}
                pageNumbers={pageNumbers}
                handleNextPage={handleNextPage}
                handlePageClick={handlePageClick}
                handlePreviousPage={handlePreviousPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                rowsPerPage={rowsPerPage}
                totalPages={totalPages}
                filteredResources={filteredResources}
            />

            <DeleteAllModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onConfirm={confirmDeleteAll}
            />

            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={closeDeleteModal}
                onConfirm={() => confirmResourceDelete(deleteModalResourceKey)}
            />

            <ExportModal
                apiURL={API_URL}
                project={project}
                isOpen={isExportModalOpen}
                onClose={closeExportModal}
                locales={locales}
            />

            <ChangesModal
                isOpen={isChangesModalOpen}
                onClose={closeModal}
                data={tempResources}
            />

            <AddKeyForm
                isVisible={isFormVisible}
                toggleFormVisibility={toggleFormVisibility}
                user={user}
                config={config}
                currentUser={currentUser}
                editingKey={editingKey}
                newKey={newKey}
                handleInputChange={handleInputChange}
                handleDescriptionChange={handleDescriptionChange}
                inputError={inputError}
                description={description}
                locales={locales}
                editedTranslations={editedTranslations}
                isHtml={isHtml}
                setIsHtml={setIsHtml}
                handleAddKey={handleAddKey}
                handleEditKey={handleEditKey}
            />

            <ImportForm
                close={() => setIsImportFormVisible(false)}
                isVisible={isImportFormVisible}
                importData={importData}
                setImportData={setImportData}
                handleImportSubmit={handleImportSubmit}
                currentUser={currentUser}
            />

            <ConfirmModal
                isOpen={isConfirmModalOpen}
                onClose={closeConfirmModal}
                onConfirm={confirmModalAction}
            />

        </div>
    );
};

export default ResourcesBlock;
